module.exports = __webpack_public_path__ + "img/video_menu_user.71e463d3.svg";